(function () {
  if (window.__announcementBarCustomReady) return;
  window.__announcementBarCustomReady = true;

  function initSlider(slider) {
    if (!slider || slider.dataset.announcementSliderInitialized === 'true') return;
    slider.dataset.announcementSliderInitialized = 'true';

    var track = slider.querySelector('[data-announcement-track]');
    var slides = slider.querySelectorAll('[data-announcement-slide]');
    if (!track || slides.length <= 1) return;

    var mobileMq = window.matchMedia('(max-width: 64rem)');
    var index = 0;
    var total = slides.length;
    var autoplay = slider.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(slider.getAttribute('data-speed'), 10) || 5000;
    var timer = null;
    var startX = 0;
    var deltaX = 0;
    var isSwiping = false;

    function isMobile() {
      return mobileMq.matches;
    }

    function updateSlider() {
      if (!isMobile()) {
        track.style.transform = 'none';
        return;
      }

      track.style.transform = 'translate3d(' + (index * -100) + '%, 0, 0)';
    }

    function goTo(newIndex) {
      if (!isMobile()) return;

      if (newIndex < 0) newIndex = total - 1;
      if (newIndex >= total) newIndex = 0;
      index = newIndex;
      updateSlider();
    }

    function next() {
      goTo(index + 1);
    }

    function prev() {
      goTo(index - 1);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || !isMobile()) return;

      timer = setInterval(function () {
        next();
      }, speed);
    }

    track.addEventListener('touchstart', function (event) {
      if (!isMobile()) return;
      if (!event.touches || !event.touches.length) return;

      startX = event.touches[0].clientX;
      deltaX = 0;
      isSwiping = true;
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchmove', function (event) {
      if (!isMobile()) return;
      if (!isSwiping || !event.touches || !event.touches.length) return;

      deltaX = event.touches[0].clientX - startX;
    }, { passive: true });

    track.addEventListener('touchend', function () {
      if (!isMobile()) return;
      if (!isSwiping) return;

      isSwiping = false;

      if (Math.abs(deltaX) > 40) {
        if (deltaX < 0) {
          next();
        } else {
          prev();
        }
      }

      startAutoplay();
    });

    function handleViewportChange() {
      stopAutoplay();
      updateSlider();
      startAutoplay();
    }

    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', handleViewportChange);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(handleViewportChange);
    }

    updateSlider();
    startAutoplay();
  }

  function initContrast(bar) {
    if (!bar || bar.dataset.mobileContrastInitialized === 'true') return;
    bar.dataset.mobileContrastInitialized = 'true';

    var toggle = bar.querySelector('[data-mobile-contrast-toggle]');
    if (!toggle) return;

    var mobileMq = window.matchMedia('(max-width: 64rem)');

    function isMobile() {
      return mobileMq.matches;
    }

    function resetDesktopState() {
      if (isMobile()) return;
      bar.classList.remove('is-mobile-contrast-active');
      toggle.setAttribute('aria-pressed', 'false');
    }

    toggle.addEventListener('click', function () {
      if (!isMobile()) return;
      var isActive = bar.classList.toggle('is-mobile-contrast-active');
      toggle.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', resetDesktopState);
    } else if (mobileMq.addListener) {
      mobileMq.addListener(resetDesktopState);
    }

    resetDesktopState();
  }

  function initAll(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-announcement-slider]')) {
      initSlider(context);
    }
    if (context.matches && context.matches('[data-mobile-contrast-bar]')) {
      initContrast(context);
    }

    context.querySelectorAll('[data-announcement-slider]').forEach(initSlider);
    context.querySelectorAll('[data-mobile-contrast-bar]').forEach(initContrast);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
